import { SET_ADVANCE_SCROLL } from '../actionConstants';

export const setAdvanceScrollAction = (payload) => {
  return {
    type: SET_ADVANCE_SCROLL,
    payload,
  };
};
